import { REACT_APP_KEYCLOAK_REALM, REACT_APP_KEYCLOAK_URL } from '../config';
import { del, get, post, put } from '../utility/http';

export async function fetchKCContexts(): Promise<any> {
  try {
    const response = await get(
      `${REACT_APP_KEYCLOAK_URL}admin/realms/${REACT_APP_KEYCLOAK_REALM}/groups`,
      true,
      {},
      true
    );
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

export async function postContext(bodyKey: any, bodyDB: any): Promise<any> {
  try {
    const response = await Promise.all([
      await post(
        `${REACT_APP_KEYCLOAK_URL}admin/realms/${REACT_APP_KEYCLOAK_REALM}/groups`,
        true,
        {},
        bodyKey,
        true
      ),
      await post('/cnc/ctx', true, {}, bodyDB)
    ]);
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

export async function putContext(idK: string, body: any): Promise<any> {
  try {
    const response = await put('/cnc/ctx?projection=EPSG:3857', true, {}, body?.bodyDB);
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

export async function delContext(  name: string, idDb: string): Promise<any> {
  try {
   
    
    const response = await del( 
      `/users/group/${name}`,
      true,
      {},
      {},
      false
    );
    await del(`/cnc/ctx/${idDb}`, true, {}, {});
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}
